var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxHourglassClock = function Svg18PxHourglassClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "18px_hourglass-clock_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.5H3.25a.75.75 0 0 0 0 1.5h.261c.056 2.751.457 4.593 1.989 6-1.532 1.407-1.932 3.249-1.989 6H3.25a.75.75 0 0 0 0 1.5h4.774a.75.75 0 0 0 0-1.5h-3.01c.069-3.06.587-4.339 2.117-5.38a.75.75 0 0 0 0-1.24C5.601 7.339 5.083 6.06 5.014 3h6.972c-.069 3.06-.587 4.339-2.117 5.38a.75.75 0 0 0 .844 1.24c2.186-1.487 2.709-3.449 2.774-6.62h.263a.75.75 0 0 0 0-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m2.312 4.95a.75.75 0 0 1-.978.409l-1.619-.665A.75.75 0 0 1 12.75 14v-1.75a.75.75 0 0 1 1.5 0v1.247l1.154.474a.75.75 0 0 1 .408.979",
    "data-color": "color-2"
  }))));
};
export default Svg18PxHourglassClock;